import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-modal';
import injectSheet from 'react-jss';
import classnames from 'classnames';

import styles from './styles/InfoModal';

export function InfoModal({ buttonText, contentLabel, classes, closeModal, iconClass, isOpen, text, title }) {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel={contentLabel}
            className={classes.modalContent}
            overlayClassName={classes.overlay}
        >
            <div className={classes.iconContainer}>
                <i className={classnames('ni', iconClass, classes.icon)} />
            </div>
            <h2 className={classes.modalTitle}>{title}</h2>
            <div className={classes.modalText}>{text}</div>
            {buttonText && (
                <div className={classes.buttonContainer}>
                    <button className={classes.button} onClick={closeModal}>
                        {buttonText}
                    </button>
                </div>
            )}
        </Modal>
    );
}

InfoModal.propTypes = {
    buttonText: PropTypes.string,
    classes: PropTypes.object,
    closeModal: PropTypes.func,
    contentLabel: PropTypes.string.isRequired,
    iconClass: PropTypes.string.isRequired,
    isOpen: PropTypes.bool,
    text: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};

export default injectSheet(styles)(InfoModal);
